module.exports = __webpack_public_path__ + "img/heading_uk.251077de.svg";